import React from 'react'
import {
    List, Datagrid, TextField as TextFieldRa, EditButton, TextInput, SimpleForm, Edit, Filter, SearchInput,
    DeleteButton, required, Create
} from 'react-admin'
import Icon from '@material-ui/icons/Label'

export const LabelsIcon = Icon

const LabelsFilter = props => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
)
export const LabelsList = ({ permissions, ...props }) => {
    return (
        <List {...props} exporter={false} title="Labels" bulkActionButtons={false} sort={{ field: 'name', order: 'ASC' }} filters={<LabelsFilter />} perPage={25}>
            <Datagrid>
                <TextFieldRa source="name" label="Nome" />
                <EditButton label="" />
                <DeleteButton label="" mutationMode={'pessimistic'} />
            </Datagrid>
        </List>
    )
}


export const LabelsEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput disabled label="Código" source="id" />
                <TextInput label="Nome" source="name" validate={validateName} />
                <TextInput label="Cor Fundo (Hex)" source="backgroundColor" />
                <TextInput label="Cor Fonte (Hex)" source="fontColor" />
            </SimpleForm>
        </Edit>
    )
}

const validateName = [required()]
export const LabelsCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Nome" source="name" validate={validateName} />
                <TextInput label="Cor Fundo (Hex)" source="backgroundColor" />
                <TextInput label="Cor Fonte (Hex)" source="fontColor" />
            </SimpleForm>
        </Create>
    )
}
